import React from "react";
import Test from "./test";

const info = {
  difficulty: "medium",
  title: "Longest Palindromic Subsequence",
  url: "longest-palindromic-subsequence",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {String} str
* @return {Number}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function longestPalindromicSubSequences(str) {
  // your code goes here        
};
`,
};

export default info;
